export default __webpack_public_path__ + "a463b5b27ff5b5f1d0cdfd7ef8f2cd56.png";